<div class="container-fluid check-in-out-report">
  <form [formGroup]="form" class="row g-3 align-items-end report-filters">
    <div class="col-xl-3 col-lg-4" *ngIf="canViewAllUsers; else currentUserField">
      <app-user-select
        [parentFormGroup]="form"
        [isInModal]="false"
        [label]="'REPORTS.CHECK_IN_OUT.USER' | translate"
      ></app-user-select>
    </div>

    <ng-template #currentUserField>
      <div class="col-xl-3 col-lg-4">
        <label class="form-label">{{ 'REPORTS.CHECK_IN_OUT.USER' | translate }}</label>
        <input class="form-control" [value]="currentUser?.names || ''" disabled />
      </div>
    </ng-template>

    <div class="col-xl-2 col-lg-3 col-sm-6 pb-2">
      <label class="form-label">{{ 'REPORTS.CHECK_IN_OUT.PERIOD_START' | translate }}</label>
      <p-calendar
        formControlName="start_date"
        [showIcon]="false"
        [monthNavigator]="true"
        [yearNavigator]="true"
        inputStyleClass="form-control"
        class="prime-ng-datapicker report-calendar"
        styleClass="d-block"
        yearRange="2020:2035"
        [locale]="en"
        dateFormat="dd.mm.yy"
        appendTo="body"
        (onSelect)="onDateChange()"
      ></p-calendar>
    </div>

    <div class="col-xl-2 col-lg-3 col-sm-6 pb-2">
      <label class="form-label">{{ 'REPORTS.CHECK_IN_OUT.PERIOD_END' | translate }}</label>
      <p-calendar
        formControlName="end_date"
        [showIcon]="false"
        [monthNavigator]="true"
        [yearNavigator]="true"
        inputStyleClass="form-control"
        class="prime-ng-datapicker report-calendar"
        styleClass="d-block"
        yearRange="2020:2035"
        [locale]="en"
        dateFormat="dd.mm.yy"
        appendTo="body"
        (onSelect)="onDateChange()"
      ></p-calendar>
    </div>

    <div class="col-xl-1 col-lg-2 col-sm-3 preset-buttons">
      <button type="button" class="btn btn-outline-primary btn-input" (click)="setCurrentWeek()">
        {{ 'REPORTS.CHECK_IN_OUT.WEEK' | translate }}
      </button>
      <button type="button" class="btn btn-outline-primary btn-input" (click)="setCurrentMonth()">
        {{ 'REPORTS.CHECK_IN_OUT.MONTH' | translate }}
      </button>
    </div>

    <div class="col-xl-auto col-lg-auto col-sm-9 actions">
      <button type="button" class="btn btn-success btn-input" (click)="loadReport()" [disabled]="form.invalid || loading">
        {{ 'REPORTS.CHECK_IN_OUT.SHOW' | translate }}
      </button>
    </div>

    <div class="col-12 filter-divider-wrap">
      <hr class="filter-divider" />
    </div>
  </form>

  <ng-container *ngIf="hasSelectedUser">
    <div class="summary-row" *ngIf="loaded">
      <div class="summary-card">
        <div class="summary-title">{{ 'REPORTS.CHECK_IN_OUT.TOTAL_HOURS' | translate }}</div>
        <div class="summary-value">{{ formatMinutes(totalMinutes) }}</div>
      </div>
    </div>

    <div class="card chart-card">
      <div class="card-body">
        <div class="spinner-wrapper" *ngIf="loading">
          <div class="spinner-border text-secondary"></div>
        </div>

        <div class="bar-chart-shell" *ngIf="chartBars.length > 0; else emptyChart">
          <div class="y-axis">
            <div
              class="y-axis-tick"
              *ngFor="let tick of chartYAxisTicks"
              [style.bottom.%]="(tick / chartMaxHours) * 100"
            >
              {{ tick }}h
            </div>
          </div>

          <div class="chart-scroll">
            <div class="plot-area" [style.min-width.px]="chartMinWidth">
              <div
                class="grid-line"
                *ngFor="let tick of chartYAxisTicks"
                [style.bottom.%]="(tick / chartMaxHours) * 100"
              ></div>

              <div
                class="bar-chart"
                [style.grid-template-columns]="'repeat(' + chartBars.length + ', minmax(40px, 1fr))'"
              >
                <div
                  class="bar-column"
                  *ngFor="let bar of chartBars"
                  [class.needs-attention]="bar.needsAttention"
                  [class.clickable]="bar.hasData"
                  (click)="bar.hasData && openDayDetails(bar)"
                  (keydown.enter)="bar.hasData && openDayDetails(bar)"
                  [attr.tabindex]="bar.hasData ? 0 : null"
                  [attr.role]="bar.hasData ? 'button' : null"
                >
                  <div class="bar-tooltip">
                    <div class="bar-tooltip-date">{{ bar.dayName }}, {{ bar.date }}</div>
                    <div class="bar-tooltip-hours">{{ formatBarHours(bar.hours) }}</div>
                    <div class="bar-tooltip-intervals">
                      <ng-container *ngIf="getBarIntervals(bar).length > 0; else noIntervals">
                        <div *ngFor="let interval of getBarIntervals(bar)">{{ interval }}</div>
                      </ng-container>
                      <ng-template #noIntervals>
                        <div>{{ 'REPORTS.CHECK_IN_OUT.NO_INTERVALS' | translate }}</div>
                      </ng-template>
                    </div>
                  </div>

                  <div class="bar-value">{{ formatBarHours(bar.hours) }}</div>
                  <div class="bar-track">
                    <div class="bar-fill" [style.height.%]="getBarHeight(bar.hours)"></div>
                  </div>
                  <div class="bar-label">{{ bar.showLabel ? bar.label : '' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ng-template #emptyChart>
          <div class="empty-chart" *ngIf="!loading">
            {{ 'REPORTS.CHECK_IN_OUT.NO_DATA' | translate }}
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #dayDetailsModal let-modal>
  <div class="modal-header">
    <div>
      <h5 class="modal-title mb-1">Clock In/Out details</h5>
      <div class="text-muted" *ngIf="selectedDay">
        {{ selectedDay.dayName }}, {{ selectedDay.date }}
        <span *ngIf="selectedDay.record?.user?.names"> · {{ selectedDay.record.user.names }}</span>
      </div>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body" *ngIf="selectedDay?.record as record">
    <div class="day-summary">
      <div><span>Total:</span> <strong>{{ formatMinutes(getRecordMinutes(record)) }}</strong></div>
      <div *ngIf="record.has_missing_check_out" class="text-danger">Missing Clock Out</div>
      <div *ngIf="record.is_under_required_time" class="text-danger">
        Required daily time of {{ record.formattedRequiredTime }} not reached
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-sm day-details-table">
        <thead>
        <tr>
          <th>#</th>
          <th>Clock In</th>
          <th>Clock Out</th>
          <th>Duration</th>
          <th>Original time</th>
          <th>Changed by / Note</th>
          <th *ngIf="canCorrect"></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let interval of record.intervals; let i = index" [class.table-danger]="interval.missing_check_out">
          <td>{{ i + 1 }}</td>
          <td>{{ formatTime(interval.check_in_at) }}</td>
          <td>
            <span *ngIf="interval.check_out_at; else missingCheckOut">{{ formatTime(interval.check_out_at) }}</span>
            <ng-template #missingCheckOut><span class="text-danger">Missing</span></ng-template>
          </td>
          <td>{{ interval.minutes !== null ? formatMinutes(interval.minutes) : '—' }}</td>
          <td>
            <ng-container *ngIf="interval.original_check_in_at || interval.original_check_out_at; else notEdited">
              <div class="original-value">
                {{ formatTime(interval.original_check_in_at) }} - {{ formatTime(interval.original_check_out_at) }}
              </div>
              <div class="updated-value">
                Updated: {{ formatTime(interval.check_in_at) }} - {{ formatTime(interval.check_out_at) }}
              </div>
            </ng-container>
            <ng-template #notEdited>—</ng-template>
          </td>
          <td>
            <div *ngIf="interval.edited_by_user_name">{{ interval.edited_by_user_name }}</div>
            <div *ngIf="interval.edited_at">{{ formatDateTime(interval.edited_at) }}</div>
            <div *ngIf="interval.edit_note" class="text-muted">{{ interval.edit_note }}</div>
            <span *ngIf="!interval.edited_at && !interval.edit_note">—</span>
          </td>
          <td *ngIf="canCorrect">
            <button
              type="button"
              class="btn btn-sm btn-outline-primary"
              [disabled]="record.is_open"
              (click)="startIntervalEdit(interval, i)"
            >
              Edit
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <form class="correction-form" [formGroup]="correctionForm" *ngIf="canCorrect && editingIntervalIndex !== null">
      <h6>Edit interval {{ editingIntervalIndex + 1 }}</h6>
      <div class="row g-3">
        <div class="col-lg-3">
          <label class="form-label">Clock In</label>
          <p-calendar
            formControlName="check_in_at"
            [timeOnly]="true"
            [showTime]="true"
            [hourFormat]="24"
            [autoZIndex]="true"
            [baseZIndex]="2000"
            dateFormat="dd.mm.yy"
            appendTo="body"
            inputStyleClass="form-control"
            styleClass="d-block"
          ></p-calendar>
        </div>
        <div class="col-lg-3">
          <label class="form-label">Clock Out</label>
          <p-calendar
            formControlName="check_out_at"
            [timeOnly]="true"
            [showTime]="true"
            [hourFormat]="24"
            [autoZIndex]="true"
            [baseZIndex]="2000"
            dateFormat="dd.mm.yy"
            appendTo="body"
            inputStyleClass="form-control"
            styleClass="d-block"
          ></p-calendar>
        </div>
        <div class="col-lg-6">
          <label class="form-label">Reason for correction</label>
          <textarea class="form-control" rows="3" formControlName="edit_note"></textarea>
        </div>
      </div>
      <div class="mt-3 d-flex gap-2">
        <button type="button" class="btn btn-success" [disabled]="correctionSaving" (click)="saveIntervalCorrection()">
          Save correction
        </button>
        <button type="button" class="btn btn-outline-secondary" [disabled]="correctionSaving" (click)="cancelIntervalEdit()">
          Cancel
        </button>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">Close</button>
  </div>
</ng-template>
